module.exports = __webpack_public_path__ + "img/evaluation-2013-materials.8d3bcf57.jpg";